import { StocksApiRemoteService } from '../../Services/api/stocks/stocks-service'
import { IStockManagerListEntity, IStocksListPayload } from '../../Services/api/stocks/stocks.interface'
import { IFormUsecase } from '../../Shared/Protocol/protocol-form-usecase'
import { Result } from '../../Shared/Protocol/protocol-result'


export class ListMangerStocksUseCase
implements IFormUsecase<string, IStockManagerListEntity> {
  constructor (private readonly StocksApi: StocksApiRemoteService) {}
    

  public async handle (
    customerId: string
  ): Promise<Result<IStockManagerListEntity>> {
    // eslint-disable-next-line no-useless-catch
    try {

      const response = await this.StocksApi.listManager(customerId)

      if (response.isFailure) {
        return response
      }

      const list = response.getValue()

      if(!list) return response

    
      return Result.ok(list)
    } catch (error: any) {
      return Result.fail(error)
    }
  }

 
}
